import React, { useEffect, useRef } from 'react';
import { Message } from './types';
import { MessageItem } from './MessageItem';

interface MessageListProps {
  messages: Message[];
  autoTranslate: boolean;
  selectedLanguageCode: string;
  isTranslating: boolean;
  onToggleTranslation: (messageId: string) => void;
  onTranslateMessage: (messageId: string) => void;
}

/**
 * Message list with auto-scroll functionality
 */
export const MessageList: React.FC<MessageListProps> = ({
  messages,
  autoTranslate,
  selectedLanguageCode,
  isTranslating,
  onToggleTranslation,
  onTranslateMessage
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to bottom when messages change
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [ messages ]);

  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-4 chat-messages">
      {messages.map((message) => (
        <MessageItem
          key={message.id}
          message={message}
          autoTranslate={autoTranslate}
          selectedLanguageCode={selectedLanguageCode}
          isTranslating={isTranslating}
          onToggleTranslation={onToggleTranslation}
          onTranslateMessage={onTranslateMessage}
        />
      ))}
      {/* Invisible element to scroll to */}
      <div ref={messagesEndRef}/>
    </div>
  );
};
